<template>
  <div class="poll" :class="{ 'fullscreen': isFullScreen }">
    <div v-if="poll">
      <div v-if="isRoomAdminLoggedIn">
         <strong class="linker" v-if="isFullScreen" @click="toggleFS()">Close Full Screen <br /></strong>
        <textarea v-model="poll.title" @input="tryUpdatePollSecure(); tryUpdateMsg()" ></textarea>
        <ul>
          <li class="barbox" :key="ppi" v-for="(pp, ppi) in poll.poll">
            <input type="text" v-model="pp.title" @input="tryUpdatePollSecure();" />
            <img v-if="!hasVote(pp, poll.poll)" @click="addVote(pp)" src="./img/thumb-off.svg" alt="">
            <img v-if="hasVote(pp)" @click="removeVote(pp)" src="./img/thumb-on.svg" alt="">
            <button @click="removePoll(pp, poll.poll)">remove</button>
            <br />
            <span class="w100" :style="getBarCSS(pp, poll.poll)">
              {{ pp.voters.length }} Votes,
              {{ getPercentage(pp, poll.poll) }}
            </span>

          </li>
          <li>
            <button @click="addPoll(poll.poll)">add poll option</button>
          </li>
          <li>
            <strong class="linker" v-if="!isFullScreen" @click="toggleFS()">Open Full Screen</strong>

          </li>
        </ul>
      </div>
      <div v-if="!isRoomAdminLoggedIn">
        <strong class="linker" v-if="isFullScreen" @click="toggleFS()">Close Full Screen <br /></strong>
        <strong>{{ poll.title }}</strong>
        <br />
        <ul>
          <li class="barbox" :key="ppi" v-for="(pp, ppi) in poll.poll">
            {{ pp.title }}
            <img v-if="!hasVote(pp, poll.poll)" @click="addVote(pp)" src="./img/thumb-off.svg" alt="">
            <img v-if="hasVote(pp)" @click="removeVote(pp)" src="./img/thumb-on.svg" alt="">
            <br />
            <!-- {{ pp.voters.length }},
            Percentage: {{ getPercentage(pp, poll.poll) }} -->
            <span class="w100" :style="getBarCSS(pp, poll.poll)">
              {{ pp.voters.length }} Votes,
              {{ getPercentage(pp, poll.poll) }}
            </span>
          </li>
        </ul>
        <strong class="linker" v-if="!isFullScreen" @click="toggleFS()">Open Full Screen</strong>

      </div>

      <!-- <pre>{{ poll }}</pre> -->
    </div>

    <!-- <pre>{{ msg }}</pre> -->
  </div>
</template>

<script>
import { API } from '@/yoteach2-gui/parts'

export default {
  props: {
    isRoomAdminLoggedIn: {},
    initFullscreen: {},
    msg: {},
    roomPW: {}
  },
  watch: {
    isRoomAdminLoggedIn () {
      this.refresh()
    },
    isFullScreen () {
      this.$emit('fullscreen', this.isFullScreen)
    }
  },
  data () {
    return {
      isFullScreen: this.initFullscreen || false,
      poll: false,
      hasItem: false
    }
  },
  methods: {
    toggleFS () {
      this.isFullScreen = !this.isFullScreen
    },
    tryUpdateMsg () {
      if (this.poll) {
        this.msg.text = this.poll.title
        API.messageChanged(this.msg)
      }
    },
    getBarCSS (pp, arr) {
      return {
        width: `calc(100% - 15px)`,
        backgroundSize: `${this.getPercentage(pp, arr)} 100%`,
        backgroundRepeat: 'no-repeat no-repeat',
        backgroundImage: `linear-gradient(90deg, rgb(255, 93, 109) 67%, rgb(255, 12, 36))`
      }
    },
    removePoll (pp, arr) {
      if (window.confirm('delete?')) {
        let idx = arr.indexOf(pp)
        if (idx !== -1) {
          arr.splice(idx, 1)
        }
        this.updatePollSecure()
      }
    },
    hasVote (pp, arr) {
      let ans = pp.voters.map(e => e.voterUUID).includes(API.Status.state.chatter.uuid)
      console.log(ans)
      return ans
    },
    addPoll (arr) {
      arr.push({
        'voters': [],
        'slug': Number(Math.random() * 1024 * 1024).toFixed(0) + '',
        'title': 'Another Option'
      })
      this.updatePollSecure()
    },
    getPercentage (pp, arr) {
      let info = arr.reduce((c, pp) => {
        c.counter += pp.voters.length
        return c
      }, { counter: 0 })
      let percentage = pp.voters.length / info.counter
      percentage = percentage || 0
      return (percentage * 100).toFixed(1) + '%'
    },
    async addVote (pp) {
      let voter = {
        voterUUID: API.Status.state.chatter.uuid,
        voterName: API.Status.state.chatter.name
      }
      let itemSlug = pp.slug
      let _id = this.poll._id

      await API.tryAddVoteToPoll({ _id, itemSlug, voter })
      API.refreshPool({
        roomID: this.msg.roomID
      })
      let pollData = await this.getPoolData()
      this.poll = pollData[0]
    },
    async removeVote (pp) {
      let voter = {
        voterUUID: API.Status.state.chatter.uuid,
        voterName: API.Status.state.chatter.name
      }
      let itemSlug = pp.slug
      let _id = this.poll._id

      await API.tryRemoveVoteFromPoll({ _id, itemSlug, voter })
      API.refreshPool({
        roomID: this.msg.roomID
      })
      let pollData = await this.getPoolData()
      this.poll = pollData[0]
    },
    async updatePollSecure () {
      if (this.poll) {
        let resp = await API.updatePollSecure({ roomAdminPassword: this.roomPW, roomID: this.msg.roomID, data: this.poll })
        console.log(resp.data)
        this.msg.refresher = Math.random()
        API.refreshPool({
          roomID: this.msg.roomID
        })
      }
    },
    tryUpdatePollSecure () {
      clearTimeout(this.updateTimeout)
      this.updateTimeout = setTimeout(() => {
        this.updatePollSecure()
      }, 500)
    },
    async createPoll () {
      let data = {
        type: 'poll',
        userID: '',
        yoMessageID: this.msg._id,
        roomID: this.msg.roomID,

        title: 'new poll',
        poll: [
          {
            slug: 'first-option',
            title: 'first option',
            voters: []
          }
        ]
      }
      let resp = await API.createSecurePoll({ roomAdminPassword: this.roomPW, roomID: this.msg.roomID, data })
      console.log(resp)
      return resp.data
    },
    async getPoolData () {
      let resp = await API.getPollByYoMessageID({ yoMessageID: this.msg._id })
      console.log(resp.data)
      return resp.data
    },
    async refresh () {
      let pollData = await this.getPoolData()
      if (pollData.length > 0) {
        this.hasItem = true
        this.poll = pollData[0]
      } else {
        this.hasItem = false
      }
      if (!this.hasItem && this.isRoomAdminLoggedIn) {
        await this.createPoll()
        let pollData = await this.getPoolData()
        this.poll = pollData[0]
      }
    }
  },
  async mounted () {
    this.refresh()
    API.onPoolRefresh(async () => {
      let pollData = await this.getPoolData()
      this.poll = pollData[0]
      this.$forceUpdate()
    })
  }
}
</script>

<style scoped>
.poll{
  color:black;
 }
 .poll.fullscreen{
   position: fixed;
   top: 0px;
   left: 0px;
   width: 100%;
   height: calc(100% - 80px);
   background: white;
   z-index: 100000000000;
   overflow: scroll;
   transform: translateZ(10px);
   padding-top: 50px;
 }
@media screen and (min-width: 767px) {
  .poll.fullscreen{
    height: 100%;
  }
}

 .poll.fullscreen > div:nth-child(1){
   margin: 30px 30px 30px 30px;
 }
 .w100{
   transition: background-size 1s;
   display: inline-block;
   width: 100%;
   border-radius: 6px;
   padding: 4px 10px;
 }
 .barbox{
   display: block;
 }

 .linker{
   position: relative;
   cursor: pointer;
 }
</style>
